"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "withFormContext", {
  enumerable: true,
  get: function get() {
    return _withFormContext["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Field = _interopRequireDefault(require("./Field"));

var _Group = _interopRequireDefault(require("./Group"));

var _context = _interopRequireDefault(require("./context"));

var _withFormContext = _interopRequireDefault(require("./withFormContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Form =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Form, _PureComponent);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getChangedData", function () {
      var newData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.data;
      var oldData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.prevProps.data;
      var keys = Object.keys(newData);

      if ((0, _lib.arrayHasItems)(keys)) {
        var data = {};
        keys.forEach(function (k) {
          if (newData[k] !== oldData[k]) {
            data[k] = newData[k];
          }
        });
        return data;
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "getContextState", function () {
      return {
        hasError: _this.hasError(),
        hasRequiredData: _this.hasRequiredData(),
        hasChanges: _this.hasChanges()
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setComponentState", function (state) {
      return new Promise(function (resolve) {
        return _this.setState(state, resolve);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Form.className];
      (0, _lib.addClassByPropName)(names, _this.props, ['disabled']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "validateAll", function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.data;

      _this.setState({
        isValidateAll: true
      });

      var promises = [];
      var keys = Object.keys(_this.validateRefs);

      if ((0, _lib.arrayHasItems)(keys)) {
        keys.forEach(function (key) {
          var ref = _this.validateRefs[key].current;

          if (ref) {
            promises.push(new Promise(function (res) {
              res(ref.handleValidate(data[key]));
            }));
          }
        });
      }

      var results = Promise.all(promises);

      _this.setState({
        isValidateAll: false
      }, function () {
        var onValidate = _this.props.onValidate;

        if (onValidate) {
          onValidate(results);
        }
      });

      return results;
    });

    _defineProperty(_assertThisInitialized(_this), "hasError", function () {
      var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.errors;
      var keys = errors ? Object.keys(errors) : [];
      return keys.some(function (key) {
        return !errors[key].isValid;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hasRequiredData", function () {
      var requiredCondition = _this.props.requiredCondition;
      var requiredKeys = _this.state.requiredKeys;

      if ((0, _lib.arrayHasItems)(requiredKeys)) {
        return requiredCondition(_this.state);
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "hasChanges", function () {
      var _this$state = _this.state,
          data = _this$state.data,
          prevProps = _this$state.prevProps;
      var keys = Object.keys(data);

      if ((0, _lib.objHasKeys)(prevProps.data)) {
        if ((0, _lib.arrayHasItems)(keys)) {
          return keys.some(function (key) {
            return data[key] !== prevProps.data[key];
          });
        }
      } else {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSubmit", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var submitAll = _this.props.submitAll;
      var data = _this.state.data;
      var finalData = submitAll ? data : _this.getChangedData();
      finalData = _this.handleFilterExcluded(finalData);

      _this.validateAll(finalData).then(function () {
        if (!_this.hasError()) {
          var onSubmit = _this.props.onSubmit;

          if (onSubmit) {
            onSubmit(e, finalData);
          }
        } else {
          var onSubmitError = _this.props.onSubmitError;

          if (onSubmitError) {
            var errors = _this.state.errors;
            onSubmitError(errors);
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterExcluded", function (data) {
      var newData = data;
      var excludedKeys = _this.state.excludedKeys;
      var keys = Object.keys(data);

      if ((0, _lib.arrayHasItems)(excludedKeys)) {
        var newKeys = keys.filter(function (k) {
          return !excludedKeys.some(function (ek) {
            return k === ek;
          });
        });
        newData = newKeys.reduce(function (result, k) {
          var output = result;
          output[k] = data[k];
          return output;
        }, {});
      }

      return newData;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var name = _ref.name,
          value = _ref.value,
          checked = _ref.checked;
      (0, _lib.callEventMethods)(e, 'persist');
      var data = _this.state.data;

      if (name) {
        data[name] = (0, _lib.isBool)(checked) ? checked : value;

        _this.setState({
          data: data
        }, function () {
          var contextState = _this.getContextState();

          var onChange = _this.props.onChange;

          if (onChange) {
            onChange(e, _objectSpread({
              name: name,
              value: value,
              checked: checked,
              data: data
            }, contextState));
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMultiChange", function (e, newData) {
      (0, _lib.callEventMethods)(e, 'persist');
      var stateData = _this.state.data;

      var data = _this.getChangedData(newData, stateData);

      if ((0, _lib.objHasKeys)(data)) {
        var keys = Object.keys(data);
        keys.forEach(function (k) {
          return _this.handleOnChange(e, {
            name: k,
            value: data[k],
            checked: data[k]
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnReset", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var disabled = _this.props.disabled;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var propsData = _this.props.data;
      var data = Object.assign({}, propsData);

      for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        keys[_key - 1] = arguments[_key];
      }

      if ((0, _lib.arrayHasItems)(keys)) {
        var stateData = _this.state.data;
        data = Object.assign({}, stateData);
        keys.forEach(function (k) {
          data[k] = propsData[k];
        });
      }

      _this.setState({
        data: data
      }, function () {
        _this.validateAll(data).then(function () {
          var onReset = _this.props.onReset;

          if (onReset) {
            onReset(e, data);
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClear", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var disabled = _this.props.disabled;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var stateData = _this.state.data;
      var objKeys = Object.keys(stateData);

      for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        keys[_key2 - 1] = arguments[_key2];
      }

      if ((0, _lib.arrayHasItems)(keys)) {
        objKeys = keys;
      }

      var data = Object.assign({}, stateData);
      objKeys.forEach(function (k) {
        var value = data[k];
        data[k] = (0, _lib.getFalsyValue)(value);
      });

      _this.setState({
        data: data
      }, function () {
        _this.validateAll(data).then(function () {
          var onReset = _this.props.onReset;

          if (onReset) {
            onReset(e, data);
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnValidate", function (result) {
      var key = result.key,
          message = result.message,
          isValid = result.isValid;
      var errors = _this.state.errors;

      if (!errors[key] || errors[key] && (errors[key].message !== message || errors[key].isValid !== isValid)) {
        errors = Object.assign({}, errors, _defineProperty({}, key, {
          message: message,
          isValid: isValid
        }));
      }

      var isValidateAll = _this.state.isValidateAll;
      var onValidate = _this.props.onValidate;

      if (!isValidateAll && onValidate) {
        onValidate(result);
      }

      var stateErrors = _this.state.errors;

      if (errors !== stateErrors) {
        _this.setState({
          errors: errors
        });
      }

      if (!isValidateAll && _this.hasError(errors)) {
        var onError = _this.props.onError;

        if (onError) {
          onError(errors);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddRef", function (name, ref) {
      if (name) {
        _this.validateRefs[name] = ref;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveRef", function (name) {
      if (name && _this.validateRefs[name]) {
        delete _this.validateRefs[name];
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddRequired", function (name) {
      var requiredKeys = _this.state.requiredKeys;

      if (name) {
        requiredKeys.push(name);

        _this.setState({
          requiredKeys: requiredKeys
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveRequired", function (name) {
      var requiredKeys = _this.state.requiredKeys;

      if (name) {
        var index = requiredKeys.findIndex(function (k) {
          return k === name;
        });

        if (index > -1) {
          requiredKeys.splice(index, 1);

          _this.setState({
            requiredKeys: requiredKeys
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddExcluded", function (name) {
      var excludedKeys = _this.state.excludedKeys;

      if (name) {
        excludedKeys.push(name);

        _this.setState({
          excludedKeys: excludedKeys
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveExcluded", function (name) {
      var excludedKeys = _this.state.excludedKeys;

      if (name) {
        var index = excludedKeys.findIndex(function (k) {
          return k === name;
        });

        if (index > -1) {
          excludedKeys.splice(index, 1);

          _this.setState({
            excludedKeys: excludedKeys
          });
        }
      }
    });

    var _data = props.data;
    _this.state = {
      prevProps: {
        data: _data
      },
      // this only store props.value
      data: Object.assign({}, _data),
      isValidateAll: false,
      errors: {},
      requiredKeys: [],
      excludedKeys: []
    };
    _this.innerRef = _react["default"].createRef();
    _this.validateRefs = {};
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          children = _this$props.children,
          className = _this$props.className,
          onReset = _this$props.onReset,
          onChange = _this$props.onChange,
          onSubmit = _this$props.onSubmit,
          onValidate = _this$props.onValidate,
          onError = _this$props.onError,
          onSubmitError = _this$props.onSubmitError,
          innerRef = _this$props.innerRef,
          validations = _this$props.validations,
          requiredCondition = _this$props.requiredCondition,
          disabled = _this$props.disabled,
          propsData = _this$props.data,
          readOnly = _this$props.readOnly,
          contextData = _this$props.contextData,
          submitAll = _this$props.submitAll,
          rest = _objectWithoutProperties(_this$props, ["as", "children", "className", "onReset", "onChange", "onSubmit", "onValidate", "onError", "onSubmitError", "innerRef", "validations", "requiredCondition", "disabled", "data", "readOnly", "contextData", "submitAll"]);

      var _this$state2 = this.state,
          data = _this$state2.data,
          errors = _this$state2.errors,
          requiredKeys = _this$state2.requiredKeys;
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var ref = innerRef || this.innerRef;
      var context = {
        contextData: contextData,
        data: data,
        disabled: disabled,
        readOnly: readOnly,
        errors: errors,
        requiredKeys: requiredKeys,
        validations: validations,
        hasError: this.hasError(),
        addRequired: this.handleAddRequired,
        removeRequired: this.handleRemoveRequired,
        hasRequiredData: this.hasRequiredData(),
        hasChanges: this.hasChanges(),
        setContext: this.setComponentState,
        onChange: this.handleOnChange,
        onMultiChange: this.handleOnMultiChange,
        onReset: this.handleOnReset,
        onClear: this.handleOnClear,
        onSubmit: this.handleOnSubmit,
        onValidate: this.handleOnValidate,
        refs: this.validateRefs,
        addRef: this.handleAddRef,
        removeRef: this.handleRemoveRef,
        addExcluded: this.handleAddExcluded,
        removeExcluded: this.handleRemoveExcluded
      };
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        ref: ref,
        className: classNames,
        onSubmit: this.handleOnSubmit,
        noValidate: true
      }), _react["default"].createElement(_context["default"].Provider, {
        value: context
      }, (0, _lib.getRenderProps)(children, context)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var data = props.data;
      return {
        // Store the previous props in state
        prevProps: {
          data: data
        },
        data: prevProps.data !== data ? Object.assign({}, data) : state.data
      };
    }
  }]);

  return Form;
}(_react.PureComponent);

exports["default"] = Form;

_defineProperty(Form, "Consumer", _context["default"].Consumer);

_defineProperty(Form, "Field", _Field["default"]);

_defineProperty(Form, "Group", _Group["default"]);

_defineProperty(Form, "className", 'MHub-Form');

_defineProperty(Form, "displayName", 'Form');

_defineProperty(Form, "defaultRequiredCondition", function (_ref2) {
  var requiredKeys = _ref2.requiredKeys,
      data = _ref2.data;

  if ((0, _lib.valueHasValue)(data)) {
    return requiredKeys.every(function (key) {
      var value = data[key];
      return (0, _lib.valueHasValue)(value);
    });
  }

  return false;
});

_defineProperty(Form, "propTypes", {
  as: _common.customPropTypes.as,
  children: _common.customPropTypes.render.isRequired,
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onValidate: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSubmitError: _propTypes["default"].func,
  innerRef: _common.customPropTypes.ref,
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  validations: _propTypes["default"].shape(_defineProperty({}, _propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].func))),
  data: _propTypes["default"].instanceOf(Object),
  contextData: _propTypes["default"].instanceOf(Object),
  requiredCondition: _propTypes["default"].func,
  submitAll: _propTypes["default"].bool
});

_defineProperty(Form, "defaultProps", {
  as: 'form',
  className: null,
  onChange: null,
  onReset: null,
  onSubmit: null,
  onValidate: null,
  onError: null,
  onSubmitError: null,
  innerRef: null,
  readOnly: false,
  disabled: false,
  validations: null,
  data: null,
  contextData: null,
  requiredCondition: Form.defaultRequiredCondition,
  submitAll: false
});